'use client';

import React from 'react';
import styled from '@emotion/styled';
import { useRouter } from 'next/navigation';
import { Typography } from '@diritto/common/style/typography';
import { ButtonSize } from 'constants/button';
import { MagnifierIcon } from 'icons/ritto/Magnifier';
import { Error } from 'ui-components/common/Error';
import { Button } from 'ui-components/common/Button';

export const ErrorStatus500 = () => {
  const router = useRouter();
  return (
    <StyledWrap>
      <Error
        icon={<MagnifierIcon />}
        title={'요청을 처리하지 못했어요.'}
        description={'잠시 후에 다시 요청해 주세요.\n(에러코드: 500)'}>
        <StyledButton
          label="홈으로 가기"
          buttonTypography={Typography.XXXSmall}
          size={ButtonSize.Small}
          onClick={() => router.refresh()}
        />
      </Error>
    </StyledWrap>
  );
};

const StyledWrap = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-bottom: 100px;
`;

const StyledButton = styled(Button)`
  > * {
    width: 100%;
  }
`;
